export default __webpack_public_path__ + "static/media/2-way-video.966db4fc.svg";